export default "__VITE_ASSET__18b5a403__"